const initial = {
    'My Regulations': [],
    'My Requirements': [],
    'My Standards': [],
    'My Tasks': []
}

const STORAGE_KEY = 'compliance-data-v5'

export function loadAll() {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) return JSON.parse(raw)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(initial))
    return initial
}

export function saveAll(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export function reset() {
    localStorage.removeItem(STORAGE_KEY)
}
